import {Component, Input, NgZone, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {DevicesService, IconProp, NavigateService} from 'ngx-satoris';
import {DocumentType, UserPermission, UserPlatformRole} from '../../shared/models/user';
import {ApiService} from '../../shared/services/api.service';
import {CartService} from '../../shared/services/cart.service';
declare const window: any;
const permissions = window.cordova?.plugins?.permissions;

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavComponent {


  @Input() data: {label?: string, icon?: IconProp, route?: string, perm?: UserPermission, guard?: boolean, tip?: string, action?: () => void}[] = [
    {
      route: '/dashboard',
      icon: 'house',
      guard: true,
      tip: 'tooltip.dashboard'
    },
    {
      label: 'menu.createRequests.DYN.'+this.api.env.type,
      guard: this.api.userRole?.isCustomer,
      action: () => {
        this.nav.to(this.cart.isShopping ? 'document-continue' : 'document-management');
      },
      tip: 'tooltip.createRequests'
    },
    {
      label: 'trips.title',
      route: '/trips',
      guard: this.api.userRole?.isCustomer && this.api.env.type === DocumentType.ZWEVISA,
      tip: 'tooltip.trips'
    },
    {
      label: 'menu.tracking',
      route: '/tracking-control',
      guard: this.api.userRole?.isCustomer && this.api.env.type === DocumentType.PASS,
      tip: 'tooltip.tracking'
    },
    {
      label: 'menu.people.DYN.' + this.api.env.type,
      guard: this.api.userRole?.isCustomer,
      action: () => {
        this.nav.to('people');
        this.cart.removeStorageOLD(this.api.userRole.isCustomer);
      },
      tip: 'tooltip.people'
    },
    {
      label: 'menu.users',
      route: '/users',
      perm: this.api.perm.ALLOW_ADMIN,
      guard: !this.api.userRole?.isCustomer,
      tip: 'tooltip.users'
    },
    {
      label: 'menu.requests.DYN.'+this.api.env.type,
      route: '/admin-request',
      perm: this.api.perm.ALLOW_CREATE,
      guard: !this.api.userRole?.isCustomer,
      tip: 'tooltip.searchManually'
    },
    {
      label: 'menu.places',
      route: '/places',
      perm: this.api.perm.ALLOW_ADMIN,
      guard: !this.api.userRole?.isCustomer,
      tip: 'tooltip.places'
    },
    {
      label: 'dashboard.my_account',
      route: '/my-account',
      guard: true,
      tip: 'tooltip.my_account'
    }
  ];
  userRoles = UserPlatformRole;
  UserPermission = UserPermission;


  constructor(public nav: NavigateService,
              public router: Router,
              public api: ApiService,
              private deviceService: DevicesService,
              private zone: NgZone,
              public cart: CartService) {}

  clickScan() {
    if(this.deviceService.isDevices('cordova')) {
      permissions.checkPermission(permissions.CAMERA, (status: any) =>{
        if(status.hasPermission) {
          this.zone.run(() => {
            this.nav.to('scan-qr');
          });
        } else {
          this.zone.run(() => {
            this.nav.to('page-permission');
          });
        }
      });
    } else {
      this.nav.to('scan-qr');
    }
  }

  protected readonly DocumentType = DocumentType;
}
